import { useLazyQuery } from "@apollo/client";

import { TEST_VCS_INTEGRATION } from "./gql";

export const useTestVCSIntegration = () => {
  const [testVCSIntegration, { data, loading }] = useLazyQuery(TEST_VCS_INTEGRATION);

  return {
    testVCSIntegration,
    data: data?.vcsIntegrationTest,
    loading,
  };
};
